// extracted by mini-css-extract-plugin
module.exports = {"divider":"idt-divider_divider__1qaty","empty":"idt-divider_empty__1k6w5"};